const styles = theme => ({
  // Main container styles
  container: {
    position: 'fixed',
    bottom: 20,
    left: 20,
    // Clear the side nav (80px) where it is shown.
    [theme.breakpoints.up('sm')]: {
      left: 100,
    },
    zIndex: 9999,
    maxWidth: 400,
    width: '100%',
    backgroundColor: '#fff',
    boxShadow: '0px 12px 48px 0px rgba(145, 158, 171, 0.48)',
    borderRadius: '12px',
    padding: '16px',
  },

  // Uploads container
  uploadsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  // Active upload item
  activeUploadItem: {
    // Empty for now, can be extended if needed
  },

  // Upload row layout
  uploadRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },

  // Circular progress container
  progressContainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  // Progress percentage text
  progressText: {
    fontSize: '10px',
    color: '#666',
    fontWeight: 500,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },

  // Upload info container
  uploadInfo: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },

  // File name text
  fileName: {
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '4px',
  },

  // Status text
  statusText: {
    fontSize: '12px',
  },

  // Action button container
  actionButtonContainer: {
    flexShrink: 0,
  },

  // Action button
  actionButton: {
    padding: '4px',
  },

  // Error button
  errorButton: {
    padding: '4px',
    color: '#f44336',
  },

  // Success button
  successButton: {
    padding: '4px',
    color: '#4caf50',
  },

  // Icon styles
  icon: {
    fontSize: '16px',
  },

  // File size text
  fileSize: {
    fontSize: '10px',
    marginBottom: '2px',
  },
})

export default styles
